import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEnvelope,
  faPhone,
  faGlobe,
  faMap,
  faHeadset,
  faUsers,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../auth/AuthContext";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import UtilMethods from "../../util/UtilMethods";
import { sendEmail } from "../../services/EmailSender";
import { useLocation, useNavigate } from "react-router-dom";
import AlertModal from "../common/AlertModal"; // Import the reusable AlertModal component

import ConsentModal from "../common/ConsentModal";
import {
  loginUser,
  fetchSabbathDetails,
  registerSabbath,
} from "../../services/AdminServices";
import { assignMeetingId } from "../../services/ZoomService"; // Import the assignMeetingId function

import countryStateData from "../../source/countryStateData"; // Adjust the import path as necessary

const SabbathRetreatRegistrationPage = () => {
  const [searchParams] = useSearchParams();
  const { user, userType, logout, login } = useAuth();

  // Get URL params as usual

  const emailEncoded = searchParams.get("email");
  const phoneEncoded = searchParams.get("phone");
  const categoryVar = searchParams.get("category") || "Online Retreat"; // Default to "Online Retreat" if not provided
  const retreatDateString = searchParams.get("date") || "08-JUN-2025"; // Default date for the retreat

  //const emailIDVar = emailEncoded ? base64Decode(emailEncoded) : null;
  //const phoneVar = phoneEncoded ? base64Decode(phoneEncoded) : null;

  const emailIDVar = emailEncoded;
  const phoneVar = phoneEncoded;
  const [recordCategory, setRecordCategory] = useState(null); // State to hold the record category

  const [showConfirmModal, setShowConfirmModal] = useState(false); // state to control modal visibility
  const [showSuccessModal, setShowSuccessModal] = useState(false); // state to control modal visibility
  const [showConsentModal, setShowConsentModal] = useState(false); // Modal visibility state
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // state to control alert visibility
  const [modalType, setModalType] = useState("sabbath"); // Default type
  const [showCancelModal, setShowCancelModal] = useState(false); // state to control modal visibility
  const location = useLocation();
  const navigate = useNavigate();
  const record = {};

  const [isApproving, setIsApproving] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [approvalMessage, setApprovalMessage] = useState("");
  const isGuest = userType === "G";
  const isAdmin = userType?.includes("A") || userType?.includes("S"); // Check if the user is an admin or super admin

  const getFieldValue = (field, defaultValue = "") => {
    if (record?.[field]) {
      return record[field];
    } else if (!(isAdmin || isGuest) && user?.[field]) {
      return user[field];
    } else {
      return defaultValue;
    }
  };

  const [formData, setFormData] = useState({
    id: "",
    zoomID: "",
    zoomInvite: "N",
    joinUrl: "",
    firstName: getFieldValue("firstName"),
    lastName: getFieldValue("lastName"),
    email: emailIDVar || getFieldValue("email"),
    phone: phoneVar || getFieldValue("phone"),
    address: getFieldValue("address"),
    city: getFieldValue("city"),
    state: getFieldValue("state"),
    zip: getFieldValue("zip"),
    country: getFieldValue("country"),
    sabbathGroup: "US",
    participantCount: "1",
    status: "New",
    category: categoryVar || "Online Retreat",
    type: "Retreat",
    errors: {},
    submittedData: null,
    isSubmitting: false,
    consentToUseData: "",
    remarks: "", // Add remarks field
    retreatDateString: retreatDateString, // Default date for the retreat
    participantCount: "1",
    zoomMeetingID: "",
  });

  const alertTimeoutRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    console.log("SabbathRetreatRegistrationPage mounted");
    //console.log("userType", userType);
    //console.log("user", user);
    //console.log("record", record);
    console.log("emailIDVar", emailIDVar);
    console.log("phoneVar", phoneVar);
    const fetchData = async () => {
      setInvalidEmail(false); // Reset invalid email state before fetching

      if (emailIDVar) {
        try {
          if (!user) {
            const response = await loginUser(
              process.env.REACT_APP_GUEST_EMAIL,
              process.env.REACT_APP_GUEST_PASSWORD
            );
            console.log("Login response:", response);
            if (!response.user || !response.token) {
              throw new Error("Invalid login response. User or token missing.");
            }
            await login({ userData: response.user, token: response.token });
          }
          const data = await fetchSabbathDetails({
            exactEmail: emailIDVar,
          });
          //UtilMethods.log("info", "fetchSabbathDetails data...", data);
          // console.log("fetchSabbathDetails data...", data);
          if (Array.isArray(data) && data.length > 0) {
            const recordCategory = data.find(
              (item) => item.category === categoryVar
            );
            if (recordCategory) {
              console.log("Already Registered", recordCategory.id);
              setRecordCategory(recordCategory);
              setFormData((prevState) => ({
                ...prevState,
                id: recordCategory.id || "",
                consentToUseData: recordCategory.consentToUseData || false,
              }));
            }
            if (data[0]?.id) {
              setFormData((prevState) => ({
                ...prevState,
                firstName:
                  recordCategory?.firstName || data[0]?.firstName || "",
                lastName: recordCategory?.lastName || data[0]?.lastName || "",
                address: recordCategory?.address || data[0]?.address || "",
                city: recordCategory?.city || data[0]?.city || "",
                state: recordCategory?.state || data[0]?.state || "",
                zip: recordCategory?.zip || data[0]?.zip || "",
                country: recordCategory?.country || data[0]?.country || "",
              }));
            } else {
              console.error("No valid ID found in the response data.");
              setInvalidEmail(true);
            }
          } else {
            console.error("No data found for the given email.");
            setInvalidEmail(true);
          }
        } catch (error) {
          console.error("Error in the response data.");
          setInvalidEmail(true);
          console.error("invalidEmail .", invalidEmail);
          console.error("Error fetching user data:", error);
        }
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailIDVar]);

  const cancelSubmit = () => {
    setFormData((prevState) => ({ ...prevState, isSubmitting: false })); // Reset isSubmitting state
    setShowConfirmModal(false); // Close the modal without submitting
  };
  // Handle field changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  // Function to handle the link click and show the modal
  const handleShowConsentModal = () => {
    setModalType("sabbath"); // Set the appropriate type
    setShowConsentModal(true); // Show the modal
  };

  // Function to close the modal
  const handleCloseConsentModal = () => {
    setShowConsentModal(false); // Hide the modal
  };
  // Function to close the modal
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false); // Hide the modal

    navigate("/", { state: { record: {} } });
    resetForm();
  };

  // Handle radio button change for category selection
  const handleCheckChange = (e) => {
    setFormData({
      ...formData,
      consentToUseData: e.target.checked,
    });
  };

  // Phone change handler
  const handlePhoneChange = (phone) => {
    setFormData((prevState) => ({
      ...prevState,
      phone: phone,
    }));
  };

  // Form validation
  const validateForm = () => {
    // console.log("validateForm formData ", formData);
    const {
      id,
      zoomID,
      zoomInvite,
      joinUrl,
      firstName,
      lastName,
      email,
      phone,
      address,
      city,
      category,
      state,
      zip,
      country,
      sabbathGroup,
      participantCount,
      consentToUseData,
    } = formData;
    const errors = {};
    //console.log("validateForm country ", country);

    if (!firstName) errors.firstName = "First Name is required";
    if (!lastName) errors.lastName = "Last Name is required";
    if (!email || !UtilMethods.validateEmail(email))
      errors.email = "Valid email is required";
    if (!phone) errors.phone = "Valid phone number is required";
    // if (!address) errors.address = "Address line 1 is required";
    // if (!city) errors.city = "City is required";
    if (!state) errors.state = "State is required";
    //if (!zip) errors.zip = "ZIP code is required";
    if (!country) errors.country = "Country is required";
    if (!sabbathGroup) errors.sabbathGroup = "Sabbath group is required";
    if (!participantCount || participantCount < 1)
      errors.participantCount = "Number of participants is required";

    if (!consentToUseData) errors.consentToUseData = "Consent is required";
    setFormData((prevState) => ({
      ...prevState,
      errors,
    }));
    console.log("validateForm errors ", errors);
    return errors;
  };
  // Handle 'Approve' button click

  // Show modal and set formData before submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length === 0) {
      setFormData((prevState) => ({
        ...prevState,
        isSubmitting: true,
      }));
      setShowConfirmModal(true); // Show the modal
    } else {
      showAlert(
        "Please fill in all required fields: " + Object.values(errors)[0],
        "danger"
      );
    }
  };
  // Handle form submission after modal confirmation
  const confirmSubmit = async () => {
    const { address, city, state, zip, country } = formData;
    const fullAddress = `${address}, ${city}, ${state}, ${zip}, ${country}`;
    try {
      // API request to submit the form
      console.log(" /n Sabbath/register formData", formData);
      let response;
      setShowConfirmModal(false); // Close the modal after submitting
      // Set the zoomMeetingID in formData if available in the response

      // Compute zoomMeetingID before submitting
      const zoomMeetingID = assignMeetingId(
        formData.category,
        formData.sabbathGroup
      );

      response = await registerSabbath({
        ...formData,
        zoomMeetingID,
      });

      // On success, set saved data and clear error
      console.log(" sabbath/register response ", response);
      if (response.data && response.data.savedData) {
        setFormData({
          id: response.data.savedData.id,
          zoomID: response.data.savedData.zoomID,
          zoomInvite: response.data.savedData.zoomInvite,
          joinUrl: response.data.savedData.joinUrl,
          firstName: response.data.savedData.firstName || user?.firstName || "",
          lastName: response.data.savedData.lastName || user?.lastName || "",
          email: response.data.savedData.email || user?.email || "",
          phone: response.data.savedData.phone || user?.phone || "",
          address: response.data.savedData.address || user?.address || "",
          city: response.data.savedData.city || user?.city || "",
          state: response.data.savedData.state || user?.state || "",
          zip: response.data.savedData.zip || user?.zip || "",
          country: response.data.savedData.country || user?.country || "",
          sabbathGroup: response.data.savedData.sabbathGroup || "US",
          consentToUseData: response.data.savedData.consentToUseData,
          status: response.data.savedData.status || "Pending",
          category: response.data.savedData.category || "Online Retreat",
          type: response.data.savedData.type || "Retreat",
          retreatDateString: response.data.savedData.retreatDateString || "",
          errors: {},
          submittedData: null,
          isSubmitting: false,
          zoomMeetingID: response.data.savedData.zoomMeetingID || "",
        }); // the response includes the saved data
      }
      //setFormData(response.data.savedData);
      const emailResponse = await sendEmail(
        formData,
        "TMP_Retreat_Registration",
        "service_sabbath"
      );
      // On success, set saved data and clear error
      console.log("##### sabbath/emailResponse response ", emailResponse);
      console.log(
        " emailResponse.error?.status #",
        emailResponse.error?.status
      );
      console.log(" emailResponse.error?.text #", emailResponse.error?.text);
      if (emailResponse.success) {
        setSuccessMessage(
          "Retreat Registration Received,You will receive an email with the Zoom details."
        );
        setShowSuccessModal(true); // Show the success modal
        showAlert(
          "Retreat Registration Received,You will receive an email with the Zoom details.",
          "success"
        );
        if (user && user.email === process.env.REACT_APP_GUEST_EMAIL) {
          // If the user is a guest, log them out
          console.log("handleCancel Sabbath Retreat, logout GUEST MODE");
          logout();
        }
      } else {
        if (emailResponse.error?.status === 422) {
          showAlert(
            `Failed to send email: ${emailResponse.error?.text || ""}`,
            "danger"
          );
        } else {
          showAlert("Failed to send email", "danger");
        }
      }

      //setFormData(response.data.savedData);
      setError("");
    } catch (error) {
      console.error("Error submitting form:", error.code);
      console.log(" sabbath/register response error ", error);
      let errorMessage = "Error submitting form. Please try again.";
      // Check if there is a response from the backend with specific error details
      if (error?.code === 409) {
        console.log(
          "409 error sabbath/register response error ",
          error?.details?.message
        );
        errorMessage = error?.details?.message;
      } else if (
        error?.response &&
        error?.response?.data &&
        error?.response?.data?.details
      ) {
        // Display detailed error from the backend if available
        errorMessage =
          error?.response?.data?.details ||
          "Error submitting form. Please try again.";
      } else if (
        error?.response &&
        error?.response?.data &&
        error?.response?.data?.error
      ) {
        // Fallback to a generic error message if no specific details are provided
        errorMessage =
          error?.response?.data?.error ||
          "Error submitting form. Please try again.";
      } else {
        // General fallback message if backend doesn't provide a structured response
        errorMessage = "Error submitting form. Please try again.";
      }
      setErrorMessage(errorMessage);
      showAlert(errorMessage, "danger");
      setShowErrorModal(true); // Show the error modal
      setFormData((prevState) => ({
        ...prevState,
        isSubmitting: false,
      }));
    }
  };

  // Alert management
  const [alert, setAlert] = useState({
    message: "",
    type: "",
  });

  const showAlert = (message, type) => {
    setAlert({ message, type });

    if (alertTimeoutRef.current) clearTimeout(alertTimeoutRef.current);

    alertTimeoutRef.current = setTimeout(() => {
      setAlert({ message: "", type: "" });
    }, 5000);
  };

  useEffect(() => {
    return () => {
      if (alertTimeoutRef.current) clearTimeout(alertTimeoutRef.current);
    };
  }, []);

  // Reset form fields and errors
  const resetForm = () => {
    setFormData({
      record: {},
      id: null,
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
      phone: user?.phone || "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      category: "Online Retreat",
      type: "Retreat",
      participantCount: "1",
      sabbathGroup: "", // Reset sabbathGroup field
      consentToUseData: false,
      errors: {},
      submittedData: null,
      isSubmitting: false,
    });
  };

  const confirmCancel = () => {
    navigate("/", { state: { record: {} } });

    resetForm();
    setShowCancelModal(false);
  };
  const handleCancel = () => {
    setFormData((prevState) => ({
      ...prevState,
      isSubmitting: false,
    }));
    setShowCancelModal(true);
  };
  const cancelCancel = () => {
    setFormData((prevState) => ({
      ...prevState,
      isSubmitting: false,
    }));
    setShowCancelModal(false);
  };
  const {
    id,
    zoomID,
    zoomInvite,
    joinUrl,
    firstName,
    lastName,
    email,
    phone,
    address,
    city,
    state,
    zip,
    country,
    category,
    type,
    sabbathGroup,
    consentToUseData,
    errors,
    isSubmitting,
  } = formData;

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">🕊️ Pentecost Retreat Registration🕊️ </h1>
          </div>
        </div>
      </div>
      {!isAdmin && (invalidEmail || !emailIDVar) ? (
        <div className="container mt-3">
          <div className="alert alert-info text-center">
            <strong>
              You are registering with an invalid email address. Please
              contact&nbsp;
              <a href="mailto:sabbath@graceanointing.org">
                sabbath@graceanointing.org
              </a>
              &nbsp;for assistance.
            </strong>
          </div>
        </div>
      ) : (
        <div className="container mt-5">
          <div className="d-flex align-items-center justify-content-center mb-4">
            <img
              src={`${process.env.PUBLIC_URL}/images/Divine Mercy.png`}
              alt="Left decoration"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "contain",
                marginRight: "15px",
              }}
            />
            <h3 className="mb-0 text-center">
              Walk Through the Way of Grace Anointing
            </h3>
            <img
              src={`${process.env.PUBLIC_URL}/images/Rosa Mystica.png`}
              alt="Right decoration"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "contain",
                marginLeft: "15px",
              }}
            />
          </div>

          <h4 className="text-center">
            <i>"‘Wherever they go, they become the fragrance of Christ"</i> - 2
            Cor 2:15
          </h4>
          {!["A", "S"].some((type) => userType?.includes(type)) && (
            <>
              <p className="text-center">
                As we prepare our hearts for the great Feast of Pentecost, we
                will be observing a <strong>10-day period </strong> of spiritual
                preparation—beginning from the{" "}
                <strong>Feast of the Ascension</strong>—with dedicated days of
                fasting and prayer.
                <br />
                On <strong>the Feast of Pentecost, June 8, 2025</strong>, we are
                truly blessed to gather for a special <strong>Retreat</strong>,
                led by <strong>Fr. Dominic Valanmanal</strong>. This sacred time
                will include deep reflection on the Word of God and powerful
                deliverance adoration, live from the{" "}
                <strong>Anakkara Marian Retreat Center</strong>.
                <br />
                The retreat will take place from{" "}
                <strong>7:00 PM to 8:30 PM CST</strong> for participants in the
                US region and will be conducted virtually via{" "}
                <strong>Zoom</strong>.
                <br />
                For any questions or clarifications, please feel free to reach
                out to us at{" "}
                <a href="mailto:sabbath@graceanointing.org">
                  sabbath@graceanointing.org
                </a>
                .
              </p>
            </>
          )}
          {/* If there is saved data, show it */}
          {recordCategory && recordCategory.id && (
            <div className="alert alert-info align-items-center">
              <p className="alert alert-success mb-1 text-center">
                <strong>
                  {" "}
                  🌿You are already Registered with below details🌿
                </strong>
                <br />
                <strong>Registration ID:</strong> {recordCategory.type} :{" "}
                {recordCategory.id}
                {recordCategory.joinUrl && (
                  <>
                    <strong> | URL:</strong>{" "}
                    <a
                      href={recordCategory.joinUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {"👉 Click Here to Join the Retreat on "}{" "}
                      {recordCategory.retreatDateString}
                    </a>
                  </>
                )}
              </p>
              {/* Add more fields as needed */}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* Row 1: First Name & Last Name */}
              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="firstNameTip"
                  >
                    <FontAwesomeIcon icon={faUser} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    name="firstName"
                    value={firstName}
                    onChange={handleChange}
                    required
                    data-tip
                    data-for="firstNameTip"
                  />
                </div>
                {errors.firstName && (
                  <small className="text-danger">{errors.firstName}</small>
                )}

                <Tooltip
                  id="firstNameTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Enter your first name
                </Tooltip>
              </div>

              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="lastNameTip"
                  >
                    <FontAwesomeIcon icon={faUser} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    name="lastName"
                    value={lastName}
                    onChange={handleChange}
                    required
                    data-tip
                    data-for="lastNameTip"
                  />
                </div>
                {errors.lastName && (
                  <small className="text-danger">{errors.lastName}</small>
                )}

                <Tooltip
                  id="lastNameTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Enter your last name
                </Tooltip>
              </div>

              {/* Row 2: Email & Phone */}
              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="emailTip"
                  >
                    <FontAwesomeIcon icon={faEnvelope} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    disabled={!isAdmin}
                    required
                    data-tip
                    data-for="emailTip"
                  />
                </div>
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}

                <Tooltip
                  id="emailTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Enter your email address
                </Tooltip>
              </div>

              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="phoneTip"
                  >
                    <FontAwesomeIcon icon={faPhone} />
                    <span className="text-danger">*</span>
                  </span>
                  <PhoneInput
                    international
                    flagUrl="https://flagcdn.com/w320/{xx}.png"
                    defaultCountry="US"
                    value={phone}
                    onChange={handlePhoneChange}
                    className="form-select"
                    placeholder="Phone Number"
                    data-tip
                    data-for="phoneTip"
                  />
                </div>
                {errors.phone && (
                  <small className="text-danger">{errors.phone}</small>
                )}

                <Tooltip
                  id="phoneTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Enter your phone number
                </Tooltip>
              </div>

              {/* Row 3: Country & State */}
              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="countryTip"
                  >
                    <FontAwesomeIcon icon={faGlobe} />
                    <span className="text-danger">*</span>
                  </span>
                  <select
                    className="form-control"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    data-tip
                    data-for="countryTip"
                  >
                    <option value="">Select Country</option>
                    {Object.keys(countryStateData).map((code) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>

                <Tooltip
                  id="countryTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Select your country
                </Tooltip>
              </div>

              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="stateTip"
                  >
                    <FontAwesomeIcon icon={faMap} />
                    <span className="text-danger">*</span>
                  </span>
                  <select
                    className="form-control"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                    disabled={!formData.country}
                    data-tip
                    data-for="stateTip"
                  >
                    <option value="">Select State</option>
                    {formData.country &&
                      countryStateData[formData.country]?.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                  </select>
                </div>

                <Tooltip
                  id="stateTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Select your state
                </Tooltip>
              </div>

              {/* Row 4: Participants & Consent */}
              <div className="col-md-6 mb-3">
                <div className="input-group">
                  <span
                    className="input-group-text"
                    data-tip
                    data-for="participantCountTip"
                  >
                    <FontAwesomeIcon icon={faUsers} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    name="participantCount"
                    min={1}
                    value={formData.participantCount}
                    onChange={handleChange}
                    required
                    placeholder="Number of Participants"
                    data-tip
                    data-for="participantCountTip"
                  />
                </div>
                {errors.participantCount && (
                  <small className="text-danger">
                    {errors.participantCount}
                  </small>
                )}

                <Tooltip
                  id="participantCountTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Total number of participants (including you)
                </Tooltip>
              </div>

              <div
                className="col-md-6 mb-3 d-flex align-items-center"
                data-tip
                data-for="consentTip"
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleShowConsentModal();
                  }}
                  className="me-2"
                >
                  Consent <span className="text-danger">*</span>
                </a>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="consentToUseData"
                  checked={consentToUseData}
                  onChange={handleCheckChange}
                />
                {errors.zoomInvite && (
                  <small className="text-danger ms-2">
                    {errors.zoomInvite}
                  </small>
                )}

                <Tooltip
                  id="consentTip"
                  place="top"
                  effect="solid"
                  clickable={true}
                >
                  Check this box to give your consent
                </Tooltip>
              </div>
            </div>

            {/* Button Row */}
            {/* If there is saved data, show it */}
            <div className="d-flex flex-column mb-3">
              {userType &&
                (userType.includes("A") || userType.includes("S")) &&
                id && (
                  <>
                    <div className="alert alert-info">
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-group d-flex align-items-center">
                            <div className="input-group">
                              <span className="input-group-text">
                                <FontAwesomeIcon
                                  icon={faUser}
                                  data-tooltip-id="userTypeTooltip"
                                />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="User Type - GA:Adults MGA:Music ,FRGA: Father ,MRC:Marian ,YGA: Youth"
                                name="type"
                                title="Type - GA:Adults MGA:Music ,FRGA: Father ,MRC:Marian ,YGA: Youth"
                                value={type}
                                onChange={handleChange}
                                data-tooltip-id="userTypeTooltip"
                              />
                              <Tooltip
                                id="userTypeTooltip"
                                place="top"
                                content="GA: Adults, MGA: Music, FRGA: Father, MRC: Marian, YGA: Youth"
                              />
                            </div>
                            {errors.type && (
                              <small className="text-danger">
                                {errors.type}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group d-flex align-items-center">
                            <div className="input-group">
                              <span className="input-group-text">
                                <FontAwesomeIcon icon={faListCheck} />
                              </span>
                              <select
                                className="form-control"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                              >
                                <option value="">Select Status</option>
                                <option value="New">New</option>
                                <option value="Approved">Approved</option>
                                <option value="Deleted">Deleted</option>
                              </select>
                            </div>
                            {errors.status && (
                              <small className="text-danger">
                                {errors.status}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group d-flex align-items-center ms-3">
                            <label
                              className="me-2"
                              data-tooltip-id="zoomInviteTooltip"
                            >
                              Zoom Invite
                            </label>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="zoomInvite"
                              checked={zoomInvite}
                              // Make it read-only
                              data-tip="Zoom Invite"
                              onChange={handleChange}
                              data-tooltip-id="zoomInviteTooltip"
                            />
                            <Tooltip
                              id="zoomInviteTooltip"
                              place="top"
                              content="Zoom invite to the participant"
                            />
                            {errors.zoomInvite && (
                              <small className="text-danger">
                                {errors.zoomInvite}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <div className="form-group d-flex align-items-center">
                            <div className="input-group">
                              <span className="input-group-text">
                                <FontAwesomeIcon
                                  icon={faHeadset}
                                  data-tooltip-id="zoomIDTooltip"
                                />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Zoom ID"
                                name="zoomID"
                                value={zoomID}
                                title="Zoom ID"
                                onChange={handleChange}
                                data-tooltip-id="zoomIDTooltip"
                              />
                              <Tooltip
                                id="zoomIDTooltip"
                                place="top"
                                content=" Zoom participant ID"
                              />
                            </div>
                            {errors.zoomID && (
                              <small className="text-danger">
                                {errors.zoomID}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group d-flex align-items-center">
                            <div className="input-group">
                              <span className="input-group-text">
                                <FontAwesomeIcon
                                  icon={faHeadset}
                                  data-tooltip-id="joinUrlTooltip"
                                />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="URL"
                                name="joinUrl"
                                value={joinUrl}
                                title="Join URL"
                                onChange={handleChange}
                                data-tooltip-id="joinUrlTooltip"
                              />
                              <Tooltip
                                id="joinUrlTooltip"
                                place="top"
                                content="Zoom join URL"
                              />
                            </div>
                            {errors.joinUrl && (
                              <small className="text-danger">
                                {errors.joinUrl}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group d-flex align-items-center">
                            <div className="input-group">
                              <span className="input-group-text">
                                <FontAwesomeIcon icon={faListCheck} />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Remarks"
                                name="remarks"
                                value={formData.remarks || ""}
                                onChange={handleChange}
                                data-tooltip-id="remarksTooltip"
                              />
                              <Tooltip
                                id="remarksTooltip"
                                place="top"
                                content="Remarks or additional notes"
                              />
                            </div>
                            {errors.remarks && (
                              <small className="text-danger">
                                {errors.remarks}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </div>

            <div className="d-flex justify-content-around gap-4 mb-3">
              <button
                type="button"
                onClick={handleCancel}
                className="btn btn-light flex-grow-1"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary flex-grow-1"
                title={
                  recordCategory && recordCategory.id
                    ? "Already Registered !!!"
                    : "Submit your registration"
                }
                disabled={
                  !!isSubmitting || !!(recordCategory && recordCategory.id) // Disable if already registered
                }
              >
                {isSubmitting ? (
                  <i className="fas fa-spinner fa-spin"></i> // Spinner for loading
                ) : recordCategory && recordCategory.id ? (
                  "Already Registered !!!"
                ) : (
                  "Submit"
                )}
                <Tooltip
                  id="submitTooltip"
                  place="top"
                  content={
                    recordCategory && recordCategory.id
                      ? "Already Registered !!!"
                      : "Submit your registration"
                  }
                />
              </button>
              {/* Display approval message */}
              {approvalMessage && (
                <div className="mt-2">
                  <p>{approvalMessage}</p>
                </div>
              )}
            </div>
          </form>

          {/* Alert Message */}
          {alert.message && (
            <div className={`alert alert-${alert.type} mt-4`} role="alert">
              {alert.message}
            </div>
          )}
        </div>
      )}
      {/* Modal for confirmation */}
      <AlertModal
        show={showConfirmModal}
        title="Confirm Sabbath Request"
        type="confirmation"
        message="Are you sure you want to register for Sabbath Retreat on June 08, with below details?"
        details={{
          "First Name": firstName,
          "Last Name": lastName,
          Email: email,
          Phone: phone,
        }}
        onCancel={cancelSubmit}
        onConfirm={confirmSubmit}
      />

      {/* Modal for confirmation */}
      <AlertModal
        show={showCancelModal}
        title="Cancel Sabbath Request"
        type="confirmation"
        message="Are you sure you want to navigate from the Sabbath Retreat Registration?"
        details={{}}
        onCancel={cancelCancel}
        onConfirm={confirmCancel}
      />
      {/* Success Modal */}
      <AlertModal
        show={showSuccessModal}
        title="Sabbath Registration Successful"
        message={successMessage}
        type="success"
        details={{}} // or pass additional details if necessary
        onCancel={handleCloseSuccessModal}
      />
      {/* Success Modal */}
      <AlertModal
        show={showErrorModal}
        title="Registration Failed"
        message={errorMessage}
        type="error"
        details={{}} // or pass additional details if necessary
        onCancel={handleCloseSuccessModal}
      />
      {/* Render the ConsentModal */}
      <ConsentModal
        show={showConsentModal}
        type={modalType}
        onCancel={handleCloseConsentModal}
      />

      <FooterPanel />
    </React.Fragment>
  );
};

export default SabbathRetreatRegistrationPage;
